module.exports = __webpack_public_path__ + "img/物流-快递驿站.c5b7579e.jpg";